import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { getFilterCondition } from 'Global/Functions/getFilterConditionTranslate';
import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

const usePartialLocalizationFilter = (
  filteredTranslation
) => {
  const { pathname } = useLocation();

  const [initialTranslations, setInitialTranslations] =
    useState(() =>
      filteredTranslation?.filter(
        getFilterCondition(pathname)
      )
    );

  useEffect(() => {
    setInitialTranslations(
      filteredTranslation?.filter(
        getFilterCondition(pathname)
      )
    );
  }, [pathname]);

  return initialTranslations;
};

export default usePartialLocalizationFilter;
